module.exports = __webpack_public_path__ + "assets/782c164439288140cfab79bb3e6339b2.jpg";